import { useInfiniteQuery } from '@tanstack/react-query';
import { queryFn, getQueryKey } from './queryFn';
import { calcNextPage } from './utils';

type HookParams = {
  limit: number;
  initPage?: number;
  enabled?: boolean;
  market?: string;
};

export const useInfiniteInvestingIdeas = ({
  limit,
  initPage = 0,
  enabled = true,
  market = 'global',
}: HookParams) => {
  return useInfiniteQuery({
    enabled,
    queryFn,
    queryKey: getQueryKey({
      limit,
      initPage,
      market,
    }),
    staleTime: 60000 * 60, // 1 hour
    initialPageParam: initPage,
    getNextPageParam: (lastPage, allPages) => {
      const lastPageItemsLength = lastPage.length;
      const allCurrentPagesLength = allPages.length;
      return calcNextPage({
        limit,
        initPage,
        lastPageItemsLength,
        allCurrentPagesLength,
      });
    },
    select(dataGql) {
      return dataGql?.pages.flat().filter(Boolean) || [];
    },
  });
};
